import { Link } from "react-router-dom";
import Header from "../../../components/feature/Header";
import Footer from "../../../components/feature/Footer";

export default function StumpGrindingPage() {
  return (
    <>
      <Header />
      <main>
        <section className="relative min-h-[55vh] flex items-center">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/1862d2e9bc55baaeca33a03d35e0d569.jpg"
              alt="Professional stump grinding service Northern Virginia"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#1e1e1e]/90 to-[#1e1e1e]/40"></div>
          </div>
          <div className="relative max-w-7xl mx-auto px-4 lg:px-8 py-20">
            <div className="max-w-xl">
              <div className="flex items-center gap-2 text-[#e8632a] text-sm font-bold uppercase tracking-widest mb-4">
                <Link to="/services" className="hover:text-white cursor-pointer">Services</Link>
                <i className="ri-arrow-right-s-line"></i>
                Stump Grinding
              </div>
              <h1 className="text-5xl lg:text-6xl font-black text-white mb-4">Stump Grinding Services</h1>
              <p className="text-white/80 text-xl mb-8">Remove ugly stumps completely with professional grinding equipment. Reclaim your yard today.</p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to="/contact" className="flex items-center justify-center gap-2 px-8 py-4 bg-[#e8632a] text-white font-black rounded-lg uppercase tracking-wide hover:bg-[#d0541e] transition-all cursor-pointer whitespace-nowrap">
                  Get Free Estimate
                </Link>
                <a href="tel:+15407764488" className="flex items-center justify-center gap-2 px-8 py-4 border-2 border-white text-white font-black rounded-lg uppercase tracking-wide hover:bg-white hover:text-[#1e1e1e] transition-all cursor-pointer whitespace-nowrap">
                  <i className="ri-phone-fill"></i>(540) 776-4488
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 lg:px-8 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="text-[#e8632a] font-bold text-sm uppercase tracking-widest block mb-3">Stump Grinding</span>
              <h2 className="text-4xl font-black text-[#1e1e1e] mb-6">Say Goodbye to Ugly Stumps</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Left-over tree stumps are more than eyesores — they're tripping hazards, attract pests and fungi, and prevent new landscaping. Our commercial stump grinders reduce stumps 12+ inches below ground level, making them invisible and allowing you to plant, seed, or build over the area.
              </p>
              <p className="text-gray-600 leading-relaxed mb-8">
                We handle stumps of any size and offer discounts for multiple stumps on the same property. The resulting wood chips can be used as mulch or hauled away — your choice.
              </p>
              <div className="grid grid-cols-2 gap-3">
                {["Any size stump", "Ground 12\"+ below grade", "Multiple stump discounts", "Wood chips as mulch", "Same-day service", "New construction ready", "Pest prevention", "Lawn restoration"].map((f) => (
                  <div key={f} className="flex items-center gap-2 text-sm text-gray-700">
                    <i className="ri-check-line text-[#e8632a] flex-shrink-0"></i>
                    <span>{f}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden h-[400px]">
              <img
                src="https://readdy.ai/api/search-image?query=stump%20grinder%20machine%20in%20action%20wood%20chips%20flying%20removing%20large%20oak%20stump%20suburban%20backyard%20close%20up%20dramatic%20action%20shot%20professional%20tree%20service&width=700&height=500&seq=sg002&orientation=landscape"
                alt="Stump grinder in action"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </section>

        <section className="py-20 bg-[#f8f6f3]">
          <div className="max-w-4xl mx-auto px-4 lg:px-8 text-center">
            <h2 className="text-4xl font-black text-[#1e1e1e] mb-4">Stump Grinding Pricing</h2>
            <p className="text-gray-500 mb-10">Pricing is based on stump diameter. Multiple stumps receive significant discounts.</p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              {[
                { label: "Small Stump", size: "Under 12\" dia.", price: "From $150", desc: "Ornamental trees, shrubs, small stumps" },
                { label: "Medium Stump", size: "12\"–24\" dia.", price: "From $250", desc: "Standard tree stumps, medium hardwoods" },
                { label: "Large Stump", size: "24\"+ dia.", price: "From $350+", desc: "Large oaks, hardwoods, complex root systems" },
              ].map((p) => (
                <div key={p.label} className="bg-white rounded-2xl p-8">
                  <h3 className="font-black text-[#1e1e1e] text-lg mb-1">{p.label}</h3>
                  <p className="text-[#e8632a] font-bold text-sm mb-3">{p.size}</p>
                  <div className="text-3xl font-black text-[#1a3a2e] mb-3">{p.price}</div>
                  <p className="text-gray-500 text-sm">{p.desc}</p>
                </div>
              ))}
            </div>
            <p className="text-gray-400 text-sm mt-6">*10% discount for 3+ stumps on same property. Prices vary based on location and accessibility.</p>
          </div>
        </section>

        <section className="py-16 bg-[#e8632a] text-center">
          <div className="max-w-3xl mx-auto px-4">
            <h2 className="text-4xl font-black text-white mb-4">Ready to Remove That Stump?</h2>
            <p className="text-white/80 mb-8">Call or request an estimate online. Fast, clean, professional service.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/contact" className="px-8 py-4 bg-white text-[#e8632a] font-black rounded-lg uppercase tracking-wide hover:bg-gray-100 cursor-pointer whitespace-nowrap">Free Estimate</Link>
              <a href="tel:+15407764488" className="px-8 py-4 border-2 border-white text-white font-black rounded-lg uppercase tracking-wide hover:bg-white hover:text-[#e8632a] transition-all cursor-pointer whitespace-nowrap flex items-center justify-center gap-2">
                <i className="ri-phone-fill"></i>(540) 776-4488
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
